import { ResidenceType } from '../quotes.types'

export const residenceHasRooms = (residenceType?: ResidenceType) => ![
  ResidenceType.StorageUnit5By5,
  ResidenceType.StorageUnit5By10,
  ResidenceType.StorageUnit10By20,
].includes(residenceType ?? '' as any)
